/* eslint new-cap: 0 */
import { map, uniqueId, isEqual } from 'lodash';
import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';
import CancelIcon from 'components/icons/Cancel';
//import { onScroll, offScroll } from 'utils/WindowUtils';
import { onScroll} from 'utils/WindowUtils';
import { bylineToString, authorsToString } from 'utils/NewsUtils';
import { DataStoreDispatcher } from 'lib/frankly';

class Video extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    clipId: PropTypes.node,
    isLive: PropTypes.bool,
    liveStreamURL: PropTypes.string,
    liveStreamSlateURL: PropTypes.string,
    liveStreamContentClassification: PropTypes.string,
    liveStreamHeadline: PropTypes.string,
    autoPlay: PropTypes.bool,
    autoStart: PropTypes.oneOf(['default', 'true', 'false'])
  }

  render() {
    if (this.props.isLive) { // WEB-4173 Enhance Video Module to support Live Streaming
      const {
        liveStreamURL = '',
        liveStreamSlateURL = '',
        liveStreamHeadline = '',
        liveStreamContentClassification = ''
      } = this.props;

      const wNVideoCanvasProps = [{
        SetFlashLiveStream: [{
          strUrl: liveStreamURL,
          strHeadline: liveStreamHeadline,
          strAdTag: liveStreamContentClassification,
          hasPreroll: true,
          strSummaryImageUrl: liveStreamSlateURL,
          mobileStreams: [{
            url: liveStreamURL,
            type: 'video/mp4'
          }]
        }]
      }];

      return <Video_withClipId {...this.props} wNVideoCanvasProps={wNVideoCanvasProps} />;
    }

    return this.props.FRN_rawResponses
      ? <Video_withFRN_rawResponses {...this.props} />
      : <Video_withClipId {...this.props} />;
  }
}


class Video_withFRN_rawResponses extends Component {
    static propTypes = {
      FRN_rawResponses: PropTypes.array,
      clipId: PropTypes.node,
      autoPlay: PropTypes.bool,
      showDockedVideo: PropTypes.bool,
      dockPosition: PropTypes.oneOf(['top-left', 'top-right', 'bottom-left', 'bottom-right']),
      wNVideoCanvasProps: PropTypes.array
    }

    static defaultProps = {
      autoPlay: false,
      showDockedVideo: false,
      dockPosition: 'bottom-right',
      wNVideoCanvasProps: []
    }

    state = {
      domCanvasId: uniqueId('divWNVideoCanvas'),
      showDock: false,
      dismissed: false
    }

    componentDidMount() {
      this._setup(this.props);
    }

    componentWillReceiveProps(nextProps) {
      if (!isEqual(this.props.FRN_rawResponses, nextProps.FRN_rawResponses)) {
        this._setup(nextProps);
      }
    }

    _dismissDockedVideo() {
      this.setState({ dismissed: true });
      this._pauseVideo();
    }

    _pauseVideo() {
      this._wNVideoCanvas.Pause();
    }

    _setup = (props) => {
      if (!props.FRN_rawResponses || props.FRN_rawResponses.length === 0) {
        return;
      }

      const {
        clipId = '',
        FRN_rawResponses: [
          {
            data: {
              id: containerId = '',
              bylines = []
            } = {}
          } = {}
        ] = [],
        autoPlay,
        showDockedVideo,
        wNVideoCanvasProps
      } = props;
      const {
        config: {
          appOptions: { language = 'en' } = {},
        } = {},
      } = this.context;

      const authors = authorsToString(map(bylines, bylineToString), language);

      const { domCanvasId } = this.state;
      const id = clipId || containerId;

      this._articleDataStoreDispatcher = new DataStoreDispatcher('franklyinc.com/article');
      this._articleDataStoreDispatcher.set('authors', authors);
      this._articleDataStoreDispatcher.set('articleId', id);

      const wNVideoCanvas = new window.WNVideoWidget('WNVideoCanvas', domCanvasId);

      wNVideoCanvas.SetStylePackage('dark');
      wNVideoCanvas.SetVariable('widgetId', 'widget_id_placeholder');
      wNVideoCanvas.SetVariable('addThisDivId', `${domCanvasId}_addThis`);
      wNVideoCanvas.SetVariable('incanvasAdDivId', `${domCanvasId}_adDiv`);
      wNVideoCanvas.SetSkin(window.CANVAS_SKINS.flat.ebony);
      wNVideoCanvas.SetVariable('toolsShareButtons', 'link,share');
      wNVideoCanvas.SetVariable('overlayShareButtons', 'link,share');
      wNVideoCanvas.SetVariable('transportShareButtons', 'cc');
      // These values have to be set, but to override the CSS values that are appended with 'px', we give dummy values
      wNVideoCanvas.SetWidth('auto');
      wNVideoCanvas.SetHeight('auto');

      wNVideoCanvas.SetVariable('isAutoStart', autoPlay);

      /**
       * Generic addition function call for WNVideoCanvas
       * For example: [{
       *  SetVariable: ['isAutoStart', false], //key is function name, value is params
       *  SetStylePackage: ['dark']
       * }, {
       *  SetVariable: ['toolsShareButtons', 'link']
       * }]
       * Will turn into:
       * wNVideoCanvas.SetVariable('isAutoStart', false);
       * wNVideoCanvas.SetStylePackage('dark');
       * wNVideoCanvas.SetVariable('toolsShareButtons', 'link');
       */
      wNVideoCanvasProps.forEach((item) => {
        Object.keys(item).forEach((functionName) => {
          wNVideoCanvas[functionName](...item[functionName]);
        });
      });

      this._wNVideoCanvas = wNVideoCanvas;
      this._wNVideoCanvas.SetVariable('clipId', id);
      this._wNVideoCanvas.RenderWidget();

      if (showDockedVideo) {
        this._dockVideoOnScrollListener = onScroll(
          {
            element: document.getElementById(`${domCanvasId}-container`),
            ratio: 0.5
          },
          () => {
            const { showDock } = this.state;
            if (!showDock) {
              this.setState({ showDock: true });
            }
          },
          () => {
            const { showDock } = this.state;
            if (showDock) {
              this.setState({ showDock: false });
            }
          }
        );
      }
    }

    render() {
      if (!this.props.FRN_rawResponses || this.props.FRN_rawResponses.length === 0) {
        return null;
      }

      const {
        FRN_rawResponses: [
          {
            data: {
              id: containerId = ''
              } = {}
            } = {}
          ] = [],
        clipId = '',
        dockPosition
      } = this.props;

      const { domCanvasId, showDock, dismissed } = this.state;
      const id = clipId || containerId;

      if (!id) {
        return null;
      }

      const videoWrapperClassName = classNames('Video-wrapper', {'Video-wrapper--dock': showDock && !dismissed});
      const videoContentClassName = classNames('Video-content', { [`Video-content--${dockPosition}`]: dockPosition });

      return (
        <div id={`${domCanvasId}-container`} className="Video">
          <div className={videoWrapperClassName}>
            <div className={videoContentClassName}>
              <div className="Video-dismissBtn" onClick={() => this._dismissDockedVideo()}><CancelIcon color="#FFFFFF" /></div>
              <div id={domCanvasId} className="Video-canvas "></div>
            </div>
          </div>
        </div>
      );
    }
}


class Video_withClipId extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    clipId: PropTypes.node,
    autoPlay: PropTypes.bool,
    showDockedVideo: PropTypes.bool,
    dockPosition: PropTypes.oneOf(['top-left', 'top-right', 'bottom-left', 'bottom-right']),
    wNVideoCanvasProps: PropTypes.array,
    isLive: PropTypes.bool,
    autoStart: PropTypes.oneOf(['default', 'true', 'false'])
  }

  static defaultProps = {
    autoPlay: false,
    showDockedVideo: false,
    dockPosition: 'bottom-right',
    wNVideoCanvasProps: [],
    isLive: false,
    autoStart: 'default'
  }

  state = {
    domCanvasId: uniqueId('divWNVideoCanvas'),
    showDock: false,
    dismissed: false,
  }

  componentDidMount() {
    this._setup();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showDockedVideo && !this._dockVideoOnScrollListener) {
      this._addScrollListenerToVideo();
    }
  }

  _dismissDockedVideo() {
    this.setState({ dismissed: true });
    this._pauseVideo();
  }

  _pauseVideo() {
    this._wNVideoCanvas.Pause();
  }

  _addScrollListenerToVideo = () => {
    const { domCanvasId } = this.state;

    this._dockVideoOnScrollListener = onScroll(
      {
        element: document.getElementById(`${domCanvasId}-container`),
        ratio: 0.5
      },
      () => {
        const { showDock } = this.state;
        if (!showDock) {
          this.setState({ showDock: true });
        }
      },
      () => {
        const { showDock } = this.state;
        if (showDock) {
          this.setState({ showDock: false });
        }
      }
    );
  }

  _setup = () => {
    const {
      clipId = '',
      autoPlay,
      showDockedVideo,
      wNVideoCanvasProps,
      autoStart,
      isLive
    } = this.props;

    const authors = '';

    const { domCanvasId } = this.state;
    const id = clipId;

    this._articleDataStoreDispatcher = new DataStoreDispatcher('franklyinc.com/article');
    this._articleDataStoreDispatcher.set('authors', authors);
    this._articleDataStoreDispatcher.set('articleId', id);

    const wNVideoCanvas = new window.WNVideoWidget('WNVideoCanvas', domCanvasId);

    wNVideoCanvas.SetStylePackage('dark');
    wNVideoCanvas.SetVariable('widgetId', 'widget_id_placeholder');
    wNVideoCanvas.SetVariable('addThisDivId', `${domCanvasId}_addThis`);
    wNVideoCanvas.SetVariable('incanvasAdDivId', `${domCanvasId}_adDiv`);
    wNVideoCanvas.SetSkin(window.CANVAS_SKINS.flat.ebony);
    wNVideoCanvas.SetVariable('toolsShareButtons', 'link,share');
    wNVideoCanvas.SetVariable('overlayShareButtons', 'link,share');
    wNVideoCanvas.SetVariable('transportShareButtons', 'cc');
    // These values have to be set, but to override the CSS values that are appended with 'px', we give dummy values
    wNVideoCanvas.SetWidth('auto');
    wNVideoCanvas.SetHeight('auto');

    const isAutoPlay = isLive ? autoStart : autoPlay;
    if (isAutoPlay !== 'default') {
      wNVideoCanvas.SetVariable('isAutoStart', isAutoPlay);
    }

    /**
     * Generic addition function call for WNVideoCanvas
     * For example: [{
     *  SetVariable: ['isAutoStart', false], //key is function name, value is params
     *  SetStylePackage: ['dark']
     * }, {
     *  SetVariable: ['toolsShareButtons', 'link']
     * }]
     * Will turn into:
     * wNVideoCanvas.SetVariable('isAutoStart', false);
     * wNVideoCanvas.SetStylePackage('dark');
     * wNVideoCanvas.SetVariable('toolsShareButtons', 'link');
     */
    wNVideoCanvasProps.forEach((item) => {
      Object.keys(item).forEach((functionName) => {
        wNVideoCanvas[functionName](...item[functionName]);
      });
    });

    this._wNVideoCanvas = wNVideoCanvas;
    this._wNVideoCanvas.SetVariable('clipId', id);
    this._wNVideoCanvas.RenderWidget();

    if (showDockedVideo) {
      this._addScrollListenerToVideo();
    }
  }

  render() {
    const { clipId, dockPosition, showDockedVideo, isLive } = this.props;
    const { domCanvasId, showDock, dismissed } = this.state;
    const isDockShowed = showDockedVideo && showDock;

    const id = clipId;

    if (!id && !isLive) {
      return null;
    }

    const videoWrapperClassName = classNames('Video-wrapper', {'Video-wrapper--dock': isDockShowed && !dismissed});
    const videoContentClassName = classNames('Video-content', { [`Video-content--${dockPosition}`]: dockPosition });

    return (
      <div id={`${domCanvasId}-container`} className="Video">
        <div className={videoWrapperClassName}>
          <div className={videoContentClassName}>
            <div className="Video-dismissBtn" onClick={() => this._dismissDockedVideo()}><CancelIcon color="#FFFFFF" /></div>
            <div id={domCanvasId} className="Video-canvas "></div>
          </div>
        </div>
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./app/components/media/Video.js